<template>
    <!-- 用于系统表单搜索 每四个一行 label文字自动计算 上下左右间隔16  -->
    <div >
        <el-form ref="form" :model="form"  style="margin-bottom: 16px;" >
          <div class="searchBox">
            <div v-for="(element,index) in dataList" :key="index" class="searchForm" :class="(index)%4<3?'searchMargin':''" :ref="'searchFormRef'+index" :style="dataList.length%4==0? (dataList.length-index<=4?'':'margin-bottom:24px;'):(dataList.length-index<=dataList.length%4?'':'margin-bottom:24px;')">
            <div class="search_item" >
                <div class="search_label" :ref="'search_labelRef'+index">{{element.labelName}}</div>
                <div v-if="element.type=='input'" class="search_com " :ref="'search_comRef'+index" >
                    <el-form-item  :props="element.propName">
                            <el-input
                            v-model="form[element.propName]"
                            clearable
                            placeholder="请输入内容搜索"
                            @keyup.enter.native="seachBtn"
                        ></el-input>
                    </el-form-item>
                </div>
                <div v-if="element.type=='select'" class="search_com" :ref="'search_comRef'+index">
                    <el-form-item  :props="element.propName">
                        <el-select
                        v-model="form[element.propName]"
                        value-key="value"
                        style="width:100%;"
                        @change="(val)=>selectChange(val,element.changeClick)"
                    >   
                        <el-option
                            v-for="(item,childrenIndex) in element.optionList"
                            :key="childrenIndex"
                            :label="element.optionLabel?item[element.optionLabel]:item"
                            :value="element.optionValue?item[element.optionValue]:item"
                        ></el-option>
                    </el-select>
                    </el-form-item>
                 
                </div>
                <div v-if="element.type=='radio'" class="search_com" :ref="'search_comRef'+index">
                    <el-form-item  :props="element.propName">
                        <el-radio-group v-model="form[element.propName]">
                            <el-radio v-for="(item,childrenIndex) in element.optionList" :key="childrenIndex" :label="item.value">{{item.label}}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    
                </div>
               <div v-if="element.type=='date-picker'" class="search_com" :ref="'search_comRef'+index">
                <el-form-item :props="element.propName" >
                    <el-date-picker
                            class="SearchDatePicker"
                            v-model="form[element.propName]"
                            @change="seachBtn"
                            :clearable="false"
                            :type="element.dateType?element.dateType:'daterange'"
                            :format="element.format?element.format:'yyyy-MM-dd'"
                            :value-format="element.valueFormat?element.valueFormat:'yyyy-MM-dd'"
                            :range-separator="element.separator?element.separator:'至'"
                            :start-placeholder="element.startPlace?element.startPlace:'开始日期'"
                            :end-placeholder="element.endPlace?element.endPlace:'结束日期'">
                    </el-date-picker>
                </el-form-item>
            </div>
                <div v-if="element.type=='button'" class="search_com" :ref="'search_comRef'+index">
                    <el-form-item >
                        <el-button v-for="(item,childrenIndex) in element.optionList" :key="childrenIndex" :plain="item.isplain" :size="item.size" :type="item.typePrimary" @click="btnHandle(item.handleClick)"><span v-if="item.isShow=='open'?!moreSearchItem:(item.isShow=='close'?moreSearchItem:item.isShow)">{{item.btnText}}</span> </el-button>
                    </el-form-item>
                </div>
            </div>
            </div>
          </div>
           <!-- <div >
                <el-form-item :label="'年哈哈哈哈哈：'">
                    <el-date-picker
                            v-model="date"
                            @change="seachBtn"
                            type="daterange"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
            </div> -->
        </el-form>
       
    </div>
</template>

<script>
export default {
    props: {
        dataList: {
            type: Array,
            default: () => []
        },
        form: {
            type: Object,
            default: () => {}
        },
        moreSearchItem:{
            type:Boolean,
            default:false
        }
    },
  
    data(){
        return {
            labelAutoWidth:[],
            date:['2023-12-01','2023-12-09']
        }
    },
    mounted() {
        this.setWidth('open');
    },
    methods: {
        seachBtn(){this.$parent.seachBtn()},
        selectChange(val,functionName){this.$parent[functionName](val)},
        btnHandle(functionName){
            if(functionName==='reflash'){
              this.$refs["form"].resetFields();
            }
            this.$parent[functionName]();},
        setWidth(flag){
            for(let i=0;i<this.dataList.length;i++){
                let jLableWidth=[]
                let a= this.$refs[
                    "search_labelRef" + i
                ][0].clientWidth ;
                jLableWidth.push(a)
                this.labelAutoWidth.push(a)
                  for(let j=i+4;j<this.dataList.length;j++){
                      if(j%(i+4)==0){
                        if(this.$refs["search_labelRef" + j][0]){
                            jLableWidth.push(this.$refs["search_labelRef" + j][0].clientWidth)
                        }
                      }
                  }
                  let resA=0
                  if(flag==='open'){
                     resA= Math.max(...jLableWidth)
                     // 当上下计算宽度都为0 而展开有label文字时
                     if(resA==0&&this.$refs["search_labelRef" + i][0].innerHTML.length!=0){
                        resA=this.$refs["search_labelRef" + i][0].innerHTML.length*10+30
                     }
                  }else {
                    resA= this.labelAutoWidth[i]
                  }

                let b=  this.$refs[
                        "searchFormRef" + i
                    ][0].clientWidth 
                    let w=b-resA
                    this.$refs[
                        "search_labelRef" + i
                    ][0].style.width =resA+'px'
                    this.$refs[
                        "search_comRef" + i
                    ][0].style.width =w+'px'
                   
                //datepick 设置宽度SearchDatePicker
                // let datePickerDom=document.getElementsByClassName('SearchDatePicker')[0]
                // if(datePickerDom){
                //     console.log(datePickerDom,w,0)
                //     datePickerDom.style.width=w+'px'
                //     console.log(w,i,"w")
                // }

            }
        },
    }
};
</script>

<style lang="less" scoped>
.searchBox {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
}
.searchMargin{
    margin-right:16px;
}
.searchForm {
    width: calc((100% - 48px) /4);
    .search_item {
        display: flex;
        align-items: center;
        .el-radio{
            margin-right:0px !important;
        }
        /deep/.el-radio__label{
           padding-left:3px !important;
        }
        .el-radio + .el-radio {
            margin-left:5px !important;
        }
        .search_label{
            text-align: end;
            color: rgba(0,0,0,.85);
            flex-shrink: 0;
        }
        /deep/  .el-input__inner {
           border:1px solid #DCDCDC;
        }
        /deep/ .el-input__inner::placeholder {
          color: rgba(0,0,0,.45);
         }
         /deep/ .el-range-input::placeholder{
            color: rgba(0,0,0,.45);
         }
    }
   .el-form-item{
        margin-bottom: 0 !important;
   }
//    .el-form-item__content .el-date-editor.el-input, .el-date-editor.el-input__inner{
//     width:100% !important;
//    }


}
// 传值 示例
// formList:[
//                 {
//                     type:'select',
//                     propName:'year',
//                     labelName:'年份：',
//                     optionList:this.yearsList,
//                     changeClick:'yearsChange',
//                     isShow:true
//                 },
//                 {
//                     type:'input',
//                     propName:'businessCode',
//                     labelName:'编号：',
//                     isShow:true
//                 },
//                 {
//                     type:'select',
//                     propName:'witnessMod',
//                     labelName:'见证方式：',
//                     optionList:this.witnessModlist,
//                     changeClick:'seachBtn',
//                     optionLabel:'name',
//                     optionValue:'value',
//                     isShow:'close'
//                 },
//                 {
//                     type:'radio',
//                     propName:'importantPrj',
//                     labelName:'项目关注度：',
//                     optionList:[{label:'全部项目',value:-1},{label:'重点关注项目',value:1},{label:'非重点关注项目',value:0}],
//                     isShow:'close'
//                 },
//                 {
//                     type:'button',
//                     optionList:[{
//                         typePrimary:'primary',
//                         isplain:true,
//                         size:'small',
//                         handleClick:'reflash',
//                         btnText:'重置',
//                         isShow:true
//                     },{
//                         typePrimary:'primary',
//                         isplain:false,
//                         size:'small',
//                         handleClick:'seachBtn',
//                         btnText:'搜索',
//                         isShow:true
//                     },{
//                         typePrimary:'text',
//                         isplain:false,
//                         size:'mini',
//                         handleClick:'openSearch',
//                         btnText:'| 展开',
//                         isShow:'open'
//                     },{
//                         typePrimary:'text',
//                         isplain:false,
//                         size:'mini',
//                         handleClick:'closeSearch',
//                         btnText:'| 收起',
//                         isShow:'close'
//                     }],
//                 }
//             ],
</style>